import styled, { css } from 'styled-components';
import Carousel from 'nuka-carousel';
import { ProductArea, useZakeke } from 'zakeke-configurator-react';
import React from 'react';
import { P, PLACEHOLDERS } from '../Placeholder';

export const CarouselContainer = styled(Carousel)`
  border-bottom: 2px solid #c4c4c4;
  position: relative;
`;
export const hasTextOrImageItemsInAreaByName = (
  areaName: string,
  areas: ProductArea[],
  items: any[]
): boolean => {
  const area = areas.find((a) => a.name.trim().toLowerCase() === areaName.trim().toLowerCase());
  console.log(area);
  if (!area) return false;

  return items.some((item) => item.areaId === area.id && item.type === 0);
};
export const hasTextOrImageItemsInAreaByName1 = (
  areaName: string,
  areas: ProductArea[],
  items: any[]
): boolean => {
  const area = areas.find((a) => a.name.trim().toLowerCase() === areaName.trim().toLowerCase());
  if (!area) return false;

  return items.some((item) => item.areaId === area.id && (item.type === 0 || item.type === 1));
};

export const hasTextOrImageItemsInAreaByPlaceholder = (
  placeholder: string,
  areas: ProductArea[],
  items: any[],
  checkImageItems: boolean = true
): boolean => {
  const area = areas.find((a) => P.contains(a.name, placeholder));
  if (!area) return false;
  return items.some((item) => item.areaId === area.id && item.type === 0);
};

export const hasTextOrImageItemsInAreaByPlaceholder1 = (
  placeholder: string,
  areas: ProductArea[],
  items: any[],
  checkImageItems: boolean = true
): boolean => {
  const area = areas.find((a) => P.contains(a.name, placeholder));
  if (!area) return false;
  return items.some(
    (item) => item.areaId === area.id && (item.type === 0 || (checkImageItems && item.type === 1))
  );
};

export const calculateAreaPriceByName = (
  areaName: string,
  areas: ProductArea[],
  items: any[]
): number => {
  const area = areas.find((a) => a.name.trim().toLowerCase() === areaName.trim().toLowerCase());
  if (!area) return 0;

  const relevantItems = items.filter(
    (item) => item.areaId === area.id && (item.type === 0 || item.type === 1)
  );

  if (relevantItems.length === 0) return 0;

  return relevantItems.reduce((total, item) => {
    return total + (item.type === 1 ? 10 : 8);
  }, 0);
};

export const clearAllWaistbandSelections = (
  groups: any[] | undefined,
  onOptionClick: (e: React.MouseEvent<HTMLElement>, option: any) => void
) => {
  if (!groups) return;

  console.log('Clearing waistband selections', groups);
  const targetGroupNames = [PLACEHOLDERS.FrontAreaKeyword, PLACEHOLDERS.BackAreaKeyword];
  const mockEvent = {
    preventDefault: () => {},
    stopPropagation: () => {},
  } as React.MouseEvent<HTMLElement>;

  targetGroupNames.forEach((groupName) => {
    const group = groups.find((g) => P.contains(g.name, groupName));
    if (!group) return;
    console.log('Processing group:', group.name);

    const firstOption = group.steps?.[0]?.attributes?.[0]?.options?.[0];
    if (firstOption && !firstOption.selected) {
      onOptionClick(mockEvent, firstOption);
    }
  });
};

export const removeItems = (areaId?: number) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { items, removeItem } = useZakeke();

  items.forEach((item) => {
    const isTextOrImage = item.type === 0 || item.type === 1;
    const inTargetArea = areaId === undefined || item.areaId === areaId;

    if (isTextOrImage && inTargetArea) {
      removeItem(item.guid);
    }
  });
};

export const removeItemsForStyle = (
  items: any[],
  removeItem: (id: string) => void,
  areaId?: number
) => {
  items.forEach((item) => {
    const isTextOrImage = item.type === 0 || item.type === 1;
    const inTargetArea = areaId === undefined || item.areaId === areaId;

    if (isTextOrImage && inTargetArea) {
      removeItem(item.guid);
    }
  });
};

export const SvgArrowDownBlack: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="22"
    height="22"
    fill="black"
    {...props}
  >
    <path d="M16 22L6 12l1.4-1.4 8.6 8.6 8.6-8.6L26 12z" />
    <path fill="none" d="M0 0h32v32H0z" />
  </svg>
);

export const ImagesList = styled.ul`
  padding-left: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  grid-gap: 10px;
  overflow: auto;
  padding: 10px;
  background: #fff;
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ImageItem1 = styled.li<{ isActive: boolean }>`
  // Added isActive prop
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    border: 2px black #000;
  }
  /* Mobile: 2 columns for screens smaller than 768px */
  @media (max-width: 768px) {
    height: 90px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 5px;
    background-color: #fff;
  }

  span {
    font-size: 12px;
  }
`;

export const Icon = styled.div<{ hoverable?: boolean }>`
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;

  ${(props) =>
    props.hoverable &&
    `
    @media(hover) {
      &:hover {
        opacity: 0.5
      }
    }
  `}

  svg {
    fill: currentColor;
    width: 100%;
    height: 100%;
  }
`;

export const TextArea = styled.textarea`
  background-color: transparent;
  padding-top: 6px;
  height: 39px;
  font-family: 'Open Sans';
  padding-left: 10px;
  // padding: 10px 20px;
  color: #414042;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  border: 1px #000000 solid;
  width: 280px;
  // min-height: 35px;
  font-family: 'Open Sans';
  outline: none;
  resize: none;

  &:hover {
    // border: 1px black solid;
    border: none;
    border: 1px var(--template-primary--400) solid;
  }

  &:focus {
    // border: 1px black solid;
    // outline: none;
    border: none;
    border: 1px var(--template-primary--400) solid;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Row = styled.div`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemLabel = styled.label`
  font-size: 14px;
  display: block;
  margin-bottom: 5px;

  span {
    float: right;
    color: black;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
    }
  }
`;

export const Button = styled.button<{
  primary?: boolean;
  outline?: boolean;
  selected?: boolean;
  disabled?: boolean;
  isFullWidth?: boolean;
  uppercase?: boolean;
  children?: React.ReactNode;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${(props) => (props.isFullWidth ? '100%' : 'unset')};
  background-color: ${(props) => (props.primary ? '#313c46' : 'white')};
  color: ${(props) => (props.outline ? 'black' : props.primary ? 'white' : '#313c46')};
  min-height: 38px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: ${(props) => (props.outline ? '' : '5px 10px 5px 10px')};
  text-align: center;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'none')};
  // border: ${(props) => (props.outline ? '1px solid lightgray' : '1px solid #313c46')};
  cursor: ${(props) => (!props.disabled ? 'pointer' : 'auto')};

  ${(props) =>
    props.selected &&
    `
    border: 1px solid black;
  `}

  ${(props) =>
    !props.disabled &&
    `
      &:hover {
        background-color: ${props.outline ? 'white' : props.primary ? '#4b6074' : '#313c46'};
        border: ${props.outline ? '1px solid black' : '1px solid #4b6074'};
        color: ${props.outline ? 'black' : 'white'};
      }
  `}

  ${(props) =>
    props.disabled &&
    `
      background-color: lightgray;
      border: 1px solid gray;
      color: #313c46;
  `}

  ${Icon} + span {
    margin-left: 10px;
  }

  span {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
`;

export const AddToCartButton = styled(Button)`
  min-width: 200px;
  border: none;
  @media screen and (max-width: 786px) {
    min-width: 260px;
  }
`;

export const Columns = styled.div<{ columns: number }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
`;

export const Rows = styled.div<{ rows: number }>`
  width: 100%;
  display: grid;
  grid-template-rows: repeat(${(props) => props.rows}, 1fr);
`;

export const CloseEditorButton = styled.button`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  color: white;
  height: 60px;
  background-color: #313c46;
  height: auto;
  font-weight: bold;
  z-index: 11;
`;

const ArrowCss = css`
  position: absolute;
  left: 10px;
  top: 5px;
  background-color: #f1f1f1;
  border-radius: 30px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
`;

export const ArrowLeft = styled.div`
  ${ArrowCss};
`;
export const ArrowRight = styled.div`
  ${ArrowCss};
  left: auto;
  right: 10px;
`;

export const ArrowLeftIconStyled = styled(Icon)`
  font-size: 22px;
`;

export const ArrowRightIconStyled = styled(Icon)`
  font-size: 22px;
`;

export const TooltipContent = styled.div`
  padding: 10px;
`;
